<template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1420', '采购订单-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1419', '采购订单-明细') }}</div>
            </div>
        </div> 
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <list-item></list-item>
        </div>   
        <div v-show="actitem=='one'" style=" display:flex; width:100%;min-width:1400px; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">
            <div style="width:105px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px; ">{{ $LANG('0138', '新增记录') }} </span></el-link>
            </div>
            <el-select v-model="selparam" @change="selChg(selparam)" :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabArr" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper" size="small"  style="width:100px;height:30px; " >
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                </span>
            </el-select>
            <el-checkbox v-if="selparam=='STFG'||selparam=='ISCHK' " true-label="Y" false-label="N" border v-model="txtparam" @change="qryTabData" size="small" style="width:220px; height:31px; "> </el-checkbox>
            <el-input v-else clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:220px; height:30px; ">           
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>

          

            <div style=" font-size:12px;margin-left:5px;display:flex;min-width:120px">
                <div style="min-width:50px;font-size:12px;margin-right:4px;color:red">{{ $LANG('0944', '订单状态') }}</div>
                <el-select @change="stfgChange" v-model="stfg_" size="small" style="min-width:90px">
                    <el-option :label="$LANG('0040', '所有记录')" value="ALL"></el-option>
                    <el-option :label="$LANG('2004', '未完成')" value="NF"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                </el-select> 
            </div>
            <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                <el-button type="danger" size="small" style="height:31px">
                    {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown"  >
                    <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                    <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                    
                    <el-dropdown-item icon="iconfont icon-baocun" command="saveCond" style="line-height:40px;height:40px">{{ $LANG('0671', '保存查询条件') }}</el-dropdown-item>
 
                </el-dropdown-menu>
            </el-dropdown>
        </div> 
            <div v-show="actitem=='one'" class="ve-list-page__table">
            <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :footer-data="[]"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :event-custom-option="eventCustomOption"
                :cell-style-option="cellStyleOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :scroll-width="0"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :cellSelectionOption="{enable: false}"
                v-loading="v_loading"
                :element-loading-text="$LANG('1959', '加载中')"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                id="po_ord_table"
                ref="tabref">
            </ve-table>
            </div>
        <div v-show="actitem=='one'" style=" margin-top:5px;overflow: hidden;display:flex;background:white;font-size:12px ;padding-left:4px" class="ve-list-page__pagination">
            <div style="float: left;font-size:12px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266; font-size:12px;width:35px;margin-left:15px;line-height:35px">{{ $LANG('0349', '每页') }}</div>
            <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                <el-option 
                    v-for="item in pageList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>

            <div class="po-ord-status-legend">
                {{ $LANG('0872', '状态说明') }}：<span style="color:#808080">1、{{ $LANG('2042', '未开始：灰色') }}</span> <span style="color:blue;margin-left:6px">2、{{ $LANG('1331', '进行中：蓝色') }}</span>
                <span style="color:#b8b81b;margin-left:6px">3、{{ $LANG('1147', '逾期：黄色') }}</span><span style="color:green;margin-left:6px">  4、{{ $LANG('2037', '已完成：绿色') }}</span>
                <span style="color:#065279;margin-left:6px">5、{{ $LANG('1884', '部分完成但是提前关闭：靛蓝色') }}</span><span style="color:red;margin-left:6px"> 6、{{ $LANG('1128', '终止：红色') }}</span>
            </div>
 
        </div> 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="2vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:86vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                        <span class="spanRow">  {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem   class="item-width" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <template slot="label" v-if="item.FLDNO=='RMK'"><el-link @click="selRmk" :underline="false"><span style="border-bottom:1px solid #409eff;color:#409eff">{{item.FLDNM}}</span></el-link></template>
                                <template slot="label" v-else>{{item.FLDNM}}</template>
                                <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="small" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="small" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="small" filterable :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select size="small" :disabled="saveFlag" v-else-if="item.FLDNO==='PAYSRC'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in payArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select size="small" :disabled="saveFlag" v-else-if="item.FLDNO==='ACTNO'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in cashArr " :key="index" :label="item.ACCNM" :value="item.ACCNM"></el-option>
                                </el-select>
                                <el-select size="small" filterable v-else-if="item.key==='SUPNO'" @change="supChg" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <span v-for="(item,index) in supArr " :key="index">
                                        <el-option  :label="item.SUPLABEL" :value="item.IDSEQ"></el-option>
                                    </span>
                                </el-select>
                                <el-select size="small" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <span v-for="(item,index) in empArr " :key="index">
                                        <el-option  :label="item.EMPLABEL" :value="item.USERNM"></el-option>
                                    </span>
                                </el-select>
                                <el-input size="small" :disabled="saveFlag"  type="text"   v-else-if="item.FLDNO=='RMK'" v-model="mainRow[item.FLDNO]"></el-input>
                                <el-input size="small" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>          
                <div class="one-toolbar" style="height:35px">采购明细
                    <span   class="spanRow" >      
                        <el-link  :underline="false" @click="dtlAdd" :disabled="saveFlag">
                            【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white"> 新增</span>】
                        </el-link> 
                        <el-input clearable   v-model="txtparam3" @keyup.enter.native="qryDtl" size="small" style="width:320px; height:30px;margin-left:5px;line-height:30px;">
                            <el-button size="small" slot="append" icon="el-icon-search" @click="qryDtl" ></el-button>
                            <el-select slot="prepend" v-model="selparam3"  placeholder="请选择列名"   size="small" style="width:125px;height:30px; ">
                                <span v-for="(item ,index) in dtlCol" :key='index' >
                                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                                </span>
                            </el-select>
                        </el-input>
                        <span style="color:white;font-weight:600;font-size:12px;margin-left:15px">提示：采购单位为空时默认为库存单位</span>
                    </span>
                </div>           
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    ref="refdtl"
                    v-loading="loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    show-summary
                    :summary-method="getSummary"
                    style=" margin-top:-8px;"
                    :cell-style="{padding:'3px','font-size':'12px' }"
                    :header-cell-style="{ 'color':'#000','text-align':'center'}"
                    cell-class-name="clearPadding"
                    :row-class-name="tabRowClass"
                    :height="editHeight" 
                    :row-key="getPoKey"
                    class="custom-table-border"
                    highlight-current-row
                    @row-click="perClick" >  
                    <el-table-column label="序号" width="60" type="index" ></el-table-column>  
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox' &&item.sortable=='N' "
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red;margin-right:2px">*</span>{{item.title}}</template>  
                        <template  slot-scope="scope" >
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='MATTY'" v-text="scope.row['CMATTY']"></span>
                                <el-link  @click="qryPrc(scope.row)" :underline="false" v-else-if="item.key=='PRC'" ><span style="font-weight:600;border-bottom:1px solid red;font-size:12px">{{scope.row['PRC']}}</span></el-link>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select :ref="'pos'+scope.$index+item.key" size="mini" v-if="item.key=='MATTY'" v-model="scope.row[item.key]">
                                    <el-option label="产成品" value="PRD"></el-option>
                                    <el-option label="原材料" value="MAT"></el-option>
                                    <el-option label="样板-模具-设计服务" value="SMP"></el-option>
                                </el-select>
                                <el-select @change="modelChange" :ref="'pos'+scope.$index+item.key" v-else-if="item.key==='TAX'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <span v-for="item in taxArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                    </span>
                                </el-select>
                                <el-input :disabled="scope.row['REQNO'] &&item.key!=='POUNITNM'"  @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number"  @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.key=='PRC'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                                    <template slot="suffix" > <el-link @click="qryPrc(scope.row)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" style="color:red" ></i></el-link></template> 
                                </el-input> 
                                <el-input type="number"  @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="dtlDel(scope.row,scope.$index)" style="font-size:12px">删除</el-button>   
                        </template>
                    </el-table-column>                        
                </el-table>
                <div class="one-toolbar"  >费用明细
                    <span  class="spanRow">                  
                        <el-link  :underline="false" @click="feeAdd" :disabled="saveFlag">
                            【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white"> 新增</span>】
                        </el-link> 
                    </span>
                </div>
                <el-table  :data="feeData" 
                    border                            
                    size="small"
                    ref="reffee"
                    class="custom-table-border"
                    style=" margin-top:-8px;"
                    :cell-style="{padding:'2px'}"
                    :height="200" 
                    highlight-current-row> 
                    <el-table-column label="序号" type="index" width="55"></el-table-column>
                    <el-table-column  v-for="(item,index ) in feeCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button size="small" :disabled="saveFlag"  type="text" icon="el-icon-edit" @click="feeEdit(scope.row,scope.$index)">编辑</el-button>
                            <el-button size="small" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="feeDel(scope.row,scope.$index)">删除</el-button>   
                        </template>
                    </el-table-column>                        
                </el-table>   
                <div class="one-toolbar"  >
                    <div class="spanRow" style="display:flex;  ">附件明细 </div>
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"                     
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :max-size="10240"
                        :with-credentials="true"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :action="uploadUrl">                           
                        <div style="padding: 1px 0;width:200px;height:183px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                      
                    </Upload>              
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                                <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                                <el-link v-else :underline="false" style="margin-right:3px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button @click="saveRec" :disabled="saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
 
        <!-- 备注选择 -->
        <el-dialog v-dialogDrag :visible.sync="rmkWin" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">备注模板</span>
            </div> 
            <el-input  type="textarea" :rows="9"  v-model="tmplRmk"></el-input>
            <span slot="footer"  >
                <el-button type="info" @click="rmkWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="rmkSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 确定 </el-button> 
            </span>
        </el-dialog>
        <!-- 变更状态 -->
        <el-dialog v-dialogDrag :visible.sync="stfgWin" width="450px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">变更状态</span>
            </div>
            <div style="line-height:40px;height:40px;display:flex"> 
                <div style="width:70px">状态：</div> 
                <el-select v-model="stfgNo"  @change="stfgChg"  style="width:350px">
                    <span v-for="item in stfgArr " :key='item.CODE'>
                        <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                    </span>
                </el-select>
            </div>
            <span slot="footer"  >
                <el-button type="info" @click="stfgWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="stfgSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-yiqueren-xianxing"  > 确定 </el-button> 
            </span>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 采购明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="poWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="2vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推采购明细</span>
            </div> 
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selEvent" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">全选</span></el-checkbox>
                <span style="margin-left:6px">字段</span>
                <el-select v-model="selparam4"  placeholder="请选择列名"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryDtl" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryDtl" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextCate" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">下推选择记录</el-button>
            </div>
            <el-table  :data="dtlData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                :row-key="getDtlKey"
                :cell-style="{padding:'2px'}"
                :height="400" 
                class="custom-table-border"
                cell-class-name="clearPadding"
                highlight-current-row > 
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='STKQTY' "  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-input v-else-if="item.key=='STKRMK'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                ref="refreq"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                highlight-current-row >               
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">删除</el-button>   
                    </template>
                </el-table-column>
            </el-table>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="poWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button @click="genStk" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成入库单 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 下推单据 -->
        <el-dialog v-dialogDrag :visible.sync="nextWin" width="500px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推单据</span>
            </div>
            <div>
                <!-- <el-radio v-model="v_radio" label="STK" border>下推入库单据</el-radio> -->
                <el-radio v-model="v_radio" label="FEE" border>下推应付单据</el-radio>
            </div>
            <span slot="footer"  >
                <el-button type="info" size="small" @click="nextWin = false" style="margin-right:40px;">取 消</el-button>
                <el-button type="primary" size="small" @click="nextSure">确 定</el-button>
            </span> 
        </el-dialog>
        <!-- 费用资料框 -->
        <el-dialog  v-dialogDrag :visible.sync="feeWin"  :width="dlgWidth" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{feeFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div>
            <Form :model="feeRow" :label-width="120"  label-position="right" inline  >  
                <span v-for="(item,index) in feeCol" :key="index" >
                    <FormItem  :class=" 'item-width2'" :prop="item.key"  v-if="item.fhide==='N'"> 
                        <template slot="label"><span v-if="item.key=='FEENO'" style="color:red;margin-right:6px;">*</span>{{item.title}}</template>                 
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="feeRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number @change="feeAmt(item.key)" controls-position="right" :precision="item.dotnum" :disabled="saveFlag||item.disabled==='Y'?true:false"  v-else-if="item.edcss==='number'" v-model="feeRow[item.key]" style="width:100%" ></el-input-number>   
 
                        <el-select v-else-if="item.key==='RATE'"  @change="feeAmt(item.key)" v-model="feeRow[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in taxArr" :key="index" :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </el-select>
                        <el-select @change="comChg(item.key,feeRow[item.key],comboArr[item.key])" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="feeRow[item.key]"  filterable style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="feeRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <span slot="footer"  >
                <el-button type="info" size="small" @click="feeWin = false" style="margin-right:40px;">取 消</el-button>
                <el-button type="primary" size="small" @click="feeSure">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 下推费用明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="finWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推应付明细</span>
            </div> 
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selPay" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">全选</span></el-checkbox>
                <span style="margin-left:6px">字段</span>
                <el-select v-model="selparam4"  placeholder="请选择列名"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryFee" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryFee" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextPay" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">下推选择记录</el-button>
            </div>
            <el-table  :data="payData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                class="custom-table-border"
                :row-key="getDtlKey"
                :cell-style="{padding:'2px'}"
                cell-class-name="clearPadding"
                :height="400" 
                highlight-current-row >
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='PAYAMT'||item.key=='STKQTY' "  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-input v-else-if="item.key=='RMK'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                class="custom-table-border"
                ref="refpay"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                highlight-current-row > 
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"   type="text" icon="el-icon-close" @click="payDel(scope.row,scope.$index)">删除</el-button>   
                    </template>
                </el-table-column>
            </el-table>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="finWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button @click="genPay" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成应付单 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_random="v_random"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  v-if="prcWin" :visible.sync="prcWin" width="900px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">采购价格明细</span>
            </div> 
            <prc-list v-bind:v_row="v_poRow"></prc-list>
        </el-dialog>
    </div>  
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user'
import pubWin from '../datamgt/pubwin.vue' 
import { getDate,getDate2} from '../../api/Select'
import repWin from '../datamgt/repWin.vue' 
import prcList from '../datamgt/poprc_list.vue' 
import listItem from './po_ord_two.vue' 
import { startWorkflowInstance } from '@/utils/workflowDesigner.js'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
import FileSaver from 'file-saver'
//局部注册
export default {
    name:"po_ord",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '108',
            fieldIdseq: '108',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
            syncMainColumnSettings: true,
        })
    ],
    data () {
        return {   
            v_pct:'',       
 
            loading:false,
            finWin:false,
            nextWin:false,
            v_radio:'FEE',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            v_poRow: {},
            listurl:'',
            showViewer:false,
            v_path:'',
            prcData:[],
            poWin:false,
            selAll:'N',
            allSel:'N',
            nextData:[],
            isSame:'Y',
            v_stkqty:'',
            v_stkrmk:'',
            v_poqty:'',
            v_poprc:'',
            v_rate:'',
            v_rmk:'',
            v_idseq:'',
            stfgWin:false,
            repWin:false,
            repUrl:'',
            supArr:[],
            drawer:false,
            delData:[],
            stkCol:[],
            unitCol:[],
            dtlRow:{},
            d_stfg:false,
            saveFlag:false,
            imgData:[],
            promptWin:false,
            v_random:'',
            prompt:'',
            rmkWin:false,
            tmplRmk:'',
            stfgCss:'',
            v_search:'',
            stfgColor:'',
            mainRow:{},
            input_hold:this.$LANG('1670', '请输入内容...'),
            cashArr:[], // 
            actitem:'one',
            active:'', //二级菜单选中标志
            stfg_:'N',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            filterData:[],
            prcWin:false,
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            othBool:false,
            txtparam3:'',
            selparam3:'',
            txtparam4:'',
            selparam4:'',
            oper4:'like',
            delArr:[],
            empArr:[],
            videoUploadPercent:0,
            videoFlag:false,
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            taxArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            stfgArr:[],
            stfgNo :'',
            stfgNm:'',
            v_row:{},
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
            v_index:'',
            v_tabindex:'',
            v_tabrow:{},
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
 
            maxHeight:'',

            uploadData:{}, //上传数据
            feeCol:[],
            feeData:[],
            feeRow:{},
            feeFlag:'create',
            feeWin:false,
            feeIndex:'',
            delFee:[],
            v_commit :true,
            repArr:[],
            payData:[],
            chkIndex:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            prodCol:[],
            btnWin:false,
            v_loading:false,
            initCol:[],
            loadWin:false,
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
            },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
            },
            cellStyleOption: {
                headerCellClass: ({ column }) => (
                    column && (column.key === 'rownum' || column.field === 'index')
                        ? 'table-head-cell-class2'
                        : 'table-head-cell-class'
                ),
                bodyCellClass: ({ row }) => {
                    const statusClass = row && row.ORDSTFG === 'N' ? 'po-ord-gray-row'
                        : row && row.ORDSTFG === 'Y' ? 'po-ord-blue-row'
                            : row && row.ORDSTFG === 'PEND' ? 'po-ord-deep-row'
                                : row && row.ORDSTFG === 'OK' ? 'po-ord-green-row'
                                    : row && row.ORDSTFG === 'OVER' ? 'po-ord-yellow-row'
                                        : row && row.ORDSTFG === 'END' ? 'po-ord-end-row' : ''
                    return `table-body-cell-class1 ${statusClass}`.trim()
                },
            },
            virtualScrollOption: { enable: false },
            payArr:[],

        }
    },
    mounted () { 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','108','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        this.maxHeight = document.documentElement.clientHeight - 560
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','108','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //下推
                    this.cancelBool=true
                }if (row.ISOTH==='Y'){ //仅看本人
                    this.othBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        getBaseData('xuper_auth/getBaseData','','','','','V_Po_STFG','').then(res=>{
            this.stfgArr =res.result
        })
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','398450','','','v_sys_base',' order by sortby,idseq').then(res=>{
            res.result.forEach((item,index)=>{
                if (index ==res.result.length-1){
                    this.tmplRmk =this.tmplRmk +item['CNAME']
                }else{
                    this.tmplRmk =this.tmplRmk +item['CNAME']+'\r\n'
                }
            })
        });
        //表单所以下拦框动态赋值
        this.comSelect()
        //供应商
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','V_SYS_USER',' AND NVL(STFG,\'N\') NOT IN (\'X\')').then(res=>{
            this.empArr =res.result
        })
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14410','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.cashArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','433333','subno9',this.v_corpid,'v_sys_base','').then(res=>{
            this.payArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','108','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
        this.showkey()
        this.v_path =this.$route.path
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 535) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
        dlgWidth: function() {
            return (window.innerWidth - 300) + 'px';
        }, 
    },
    components: {
        pubWin ,
        repWin,
        listItem,
        prcList,
        VeColumnConfigDialog,
    },
    created () {       
        if (this.v_username){ 
            // 先完成主表元数据和个性化设置，再发起首次查询，避免条件白名单为空。
            this.getTabField().then(() => this.initData())
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        downFile(filePath){
            const arr_name=filePath.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(filePath,file_name)
        },
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //查看当前物料的采购价
        qryPrc(row){
            this.v_poRow =JSON.parse(JSON.stringify(row))
            this.prcWin =true
        },
        itemClick(val){
            this.actitem =val     
        },
        rowShow(){
            this.v_row = {}
            this.current = 1
            this.qryTabData()
        } ,
        //字段查询
        inputQry(){
            this.qryTabData()
        },
        forceChg(){
            this.$forceUpdate()
        },
        //字段排序
        sortHeaderColumn(column, edcss){
            const key = column && (column.key || column.field)
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) {
                this.headerSortOrder = this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.headerSortKey = key
                this.headerSortOrder = 'asc'
            }
            const direction = this.headerSortOrder === 'asc' ? 1 : -1
            const type = String(edcss || '').toLowerCase()
            const valueOf = value => (value === null || value === undefined || value === '' ? null : value)
            this.allData.sort((left, right) => {
                const leftValue = valueOf(left[key])
                const rightValue = valueOf(right[key])
                if (leftValue === rightValue) return 0
                if (leftValue === null) return 1
                if (rightValue === null) return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    const leftTime = new Date(leftValue).getTime()
                    const rightTime = new Date(rightValue).getTime()
                    if (Number.isNaN(leftTime) || Number.isNaN(rightTime)) return String(leftValue).localeCompare(String(rightValue)) * direction
                    return (leftTime - rightTime) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
            this.initPage()
        },

        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.loadWin =true   
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'108',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'采购订单'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = '采购订单_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                })    
            }  else if (val=='saveCond'){
                this.$confirm('你确定要保存当前的查询条件吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
 
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'PATH',p_value2:this.v_path,p_cond:' and userno=\''+this.v_username+'\'',p_table:'V_QRY_COND'},
                    }).then(res=>{ 
                        if (res.result.length==0){
                            let v_obj={IDSEQ:'',CORPID:this.v_corpid,PATH:this.v_path,USERNO:this.v_username,SELPARAM:this.selparam,OPER:this.oper,
                                TXTPARAM:this.txtparam,  STFG:this.stfg_}
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/formOneSave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'QRY_COND',frmid:''},
                            }).then(res=>{
                                this.$notify({title: '成功', message: '已成功保存查询条件', type: 'success' })       
                            })
                        }else{ //更新
                            let v_sel='',v_text='',v_sel2='',v_text2=''
                            if (this.selparam){
                                v_sel =this.selparam
                            }
                            if (this.txtparam){
                                v_text =this.txtparam
                            }
 
                            if (this.txtparam2){
                                v_text2 =this.txtparam2
                            }
                            let v_cond=' set selparam=\''+v_sel+'\',oper=\''+this.oper+'\',txtparam=\''+v_text+'\',stfg=\''+this.stfg_+'\''
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'idseq',p_value:res.result[0]['IDSEQ'],p_table:'QRY_COND',p_cond: v_cond},
                            }).then(res=>{ 
                                this.$notify({title: '成功', message: '已成功保存查询条件', type: 'success' })       
                            })
                        }
                    })
                }).catch(()=>{})
            }else if (val =='fldset'){
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('', '字段显示设置加载失败')
                })
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                //this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM'],TAX:obj['TAXRATE'],UNIT:obj['UNIT']} ))
                // 利用 $set 替换整个对象，确保响应式  ,PRC:obj['POPRC']               
                const targetRow = this.dtlData[this.v_tabIndex];
                // 为了保险起见，或者如果是动态新增字段，建议如下写法：
                this.$set(targetRow, 'MATNO', obj['IDNO']);
                this.$set(targetRow, 'MATNM', obj['MATNM']);
                this.$set(targetRow, 'MATDESC', obj['MATDESC']);
                this.$set(targetRow, 'MATTYNM', obj['MATTYNM']);
                this.$set(targetRow, 'UNITNM', obj['UNITNM']);
                this.$set(targetRow, 'TAX', obj['TAXRATE']);
                this.$set(targetRow, 'UNIT', obj['UNIT']);
                this.$set(targetRow, 'PRC', obj['POPRC']);


                //this.$forceUpdate()
                this.$refs['pos'+ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            }else if (this.v_key =='POUNITNM'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ POUNITNM:obj['TOUNITNM'],POUNIT:obj['TOUNIT'],RATIO:obj['RATIO']} ))
                this.chkIndex =this.v_tabIndex
            } 
            this.btnWin =false
        },
        modelChange(){
            this.$forceUpdate()
        },
        inputBtn(row,index, key){   
            this.v_key =key  
            this.v_random=Math.random()       
            if (key=='MATNO'){
                if (row['MATTY']){
                    this.v_tabRow =row
                    this.v_tabIndex =index
                    this.v_table ='v_bs_mat'
                    this.tableCol =this.prodCol
                    this.v_key2 ='modelno'
                    this.v_value2 = row['MATTY']
                    this.btnWin =true
                }else{
                    this.prompt ='请选择物品类别'
                    this.promptWin =true
                }
            }else if (key =='POUNITNM'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_UNIT'
                this.tableCol =this.unitCol
                this.v_key2 ='BSUNIT'
                this.v_value2 = row['UNIT']
                this.btnWin =true
            }
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'QTY'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            //颜色说明：1、未开始:灰色 2、进行中:蓝色 3、逾期:黄色 4、已完成:绿色 5、部分完成但是提前关闭:靛蓝色 6、终止:黑底白字
            if (row['ORDSTFG']=='N') {  //未开始
                return 'gray-row';
            }else if (row['ORDSTFG']=='Y') {  //进行中
                return 'blue-row';
            }else if (row['ORDSTFG']=='PEND') {   //部份完成
                return 'deep-row';  
            }else if (row['ORDSTFG']=='OK') {   // 完成
                return 'green-row';
            }else if (row['ORDSTFG']=='OVER') {  //逾期
                return 'yellow-row';
            }else if (row['ORDSTFG']=='END') {  //终止
                return 'end-row';
            }
        },
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        feeAmt(key){
            if (key=='PRC' ||key=='QTY'||key=='RATE'){
                var v_rate=Number(this.feeRow['RATE'])
 
                this.feeRow['AMT']=(Number(this.feeRow['QTY'])*Number(this.feeRow['PRC'])).toFixed(2)
            }
        },
        getFeeData(idseq){
            this.feeData=[]
            getTabColOrData(this.v_url,'V_po_ordfee','idseq',idseq).then((res) => {
                this.feeData =res.result  
                
            })
        },
        feeEdit(row ,index){
            this.feeRow=JSON.parse(JSON.stringify(row))
            this.feeWin=true
            this.feeFlag='edit'
            this.feeIndex=index
        } ,
 
        feeDel(row,index){
            this.$confirm('你确定要删除此费用记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.feeData.splice(index,1)
                this.delFee.push(row)
            }).catch(()=>{})
        },
        feeSure(){
            if (!this.feeRow['FEENO']){
                this.promptWin=true
                this.prompt='费用项目不能为空'
            }else{
                this.feeWin =false
                if (this.feeFlag==='edit' ){ //编辑时要替换数组记录
                    this.feeData.splice(this.feeIndex,1,this.feeRow)
                }else{
                    this.feeData.push(this.feeRow)
                }
            }
        },
        feeAdd(){
            this.feeRow={QTY:1,LSTSEQ:''}
            this.feeFlag='create'
            this.feeWin=true
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delData.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']})
                this.imgData.splice(index, 1);
            }).catch(()=>{})
        },
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listurl=path
            }
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },

        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
        // 文件上传成功时的钩子 
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})
            } else{
                this.promptWin =true
                this.prompt =res.result
            }
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getPoKey(row){
            return row.index
        },
        //生成应付单
        genPay(){
            let v_qtyFlag =false  
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt ='下推的记录不能为空' 
            }else{
                this.nextData.some(item=>{
                    if (!item['PAYAMT'] ||item['PAYAMT']==0 ){
                        v_qtyFlag =true
                    }
                })
                if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt ='请检查下推记录：应付金额>0'
                }else {
                    this.$confirm('你确定要下推生成应付单吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action =this.v_username+getDate('full')+'PO'
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/next_genpay',
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: '成功',
                                    message: '已成功下推应付单，请到费用报销单界面中查看',
                                    type: 'success'
                                });
                            }else{
                                this.promptWin =true
                                this.prompt ='下推失败！'+res.result
                            }
                            this.finWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        //生成入库单
        genStk(){
            let v_qtyFlag =false  
 
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt ='下推的记录不能为空' 
            }else{
                this.nextData.some(item=>{
                    if (!item['STKQTY'] ||item['STKQTY']==0 ){
                        v_qtyFlag =true
                    }
                })
                if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt ='请检查下推记录：收货数量>0'
                }else {
                    this.$confirm('你确定要下推生成入库单吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action =this.v_username+getDate('full')
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/next_genstk',
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: '成功',
                                    message: '已成功下推入库单，请到采购入库单界面中查看',
                                    type: 'success'
                                });
 
                            }else{
                                this.promptWin =true
                                this.prompt ='下推失败！'+res.result
                            }
                            this.poWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        //下推
        nextGen(row,index){
            this.nextWin =true
            this.v_tabrow =JSON.parse(JSON.stringify(row))
            this.v_tabindex =index
            this.v_idseq =row['IDSEQ']        
        },
        nextSure(){
            if (this.v_radio =='STK'){
                this.poWin=true
                this.getDtlData(this.v_idseq)
                this.selAll='N'
                this.nextData=[]
                this.nextWin=false
            }else{
                this.finWin=true
                this.getFeeNext(this.v_idseq)
                this.selAll='N'
                this.nextData=[]
                this.nextWin=false
            }
        },
        //全选
        selChg(val){
            if (val=='STFG' ||val =='ISCHK'){
                this.txtparam ='N'
                this.qryTabData()
            }else{
                this.txtparam =''
            }
        },
        selChg2(val){
            if (val=='STFG' ||val =='ISCHK'){
                this.txtparam2 ='N'
                this.qryTabData()
            }else{
                this.txtparam2 =''
            }
        },
        comChg(key,val,arr){    
            if (key=='FEENO'){ //费用类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.feeRow,{'FEENM':item['CNAME']})
                    }
                })
            }else if (key=='UNIT'){ //费用类型
                arr.some(item=>{
                    if (item['CODE']==val){
                        Object.assign(this.feeRow,{'UNITNM':item['CNAME']})
                    }
                })
            }
        },
        selEvent(){
            this.dtlData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
        selPay(){
            this.payData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
        //下推分配
        nextCate(){
            if (this.dtlData.filter(item=>item.SEL=='Y').length >0) {
                this.dtlData.forEach((item,index)=>{
                    if (item.SEL=='Y' &&item['ISNEXT']=='N' ){    
                        let v_okqty =0 ,v_poqty=0,v_stkqty=0  //已入库数 ,采购数，收货数
                        if (item['OKQTY']){
                            v_okqty =Number(item['OKQTY'])
                        }
                        if (item['STKQTY']){  //收货数
                            v_stkqty =Number(item['STKQTY'])
                        }
                         if (item['QTY']){  //采购数
                            v_poqty =Number(item['QTY'])
                        }
                        let v_over =Number(v_okqty+v_stkqty -v_poqty)
                        if (v_over>0 ) {
                            this.$confirm('产品编码：'+item['MATNO']+'已入库数量已超出采购数量'+v_over+'，要继续下推吗？','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                type:'info',
                            }).then(()=>{
                                this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                                this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                            }).catch(err =>{})
                        }else {                          
                            this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))                        
                            this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                        }
                    }           
                })
            }else{
                this.promptWin =true
                this.prompt ='请选择记录'
            }
        },
        nextPay(){    
            if (this.payData.filter(item=>item.SEL=='Y').length >0) {
                this.payData.forEach((item,index)=>{
                    if (item.SEL=='Y' &&item['ISNEXT']=='N' ){    
                        item['ISNEXT']='Y'
                        this.payData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                        this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                    }            
                })
            }else{
                this.promptWin =true
                this.prompt ='请选择记录'
            }
        },
        nextDel(row,index){
            this.dtlData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        payDel(row,index){
            this.payData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        //明细分配
        alloCate(){
            // 采购数量、 单价、税率 v_poqty,v_poprc,v_rate
            this.dtlData.forEach((item,index)=>{
                if (item.SEL=='Y'){
                    if (this.v_poqty){ //采购数 
                        this.dtlData.splice(index,1,Object.assign(item,{QTY:this.v_poqty}))
                    }
                    if (this.v_poprc){ // 单价
                        this.dtlData.splice(index,1,Object.assign(item,{PRC:this.v_poprc}))
                    }
                    if (this.v_rate){  //税率
                        this.dtlData.splice(index,1,Object.assign(item,{TAX:this.v_rate}))
                    }
             
                    let v_tax =item['TAX']?Number(item['TAX']):0
                    let v_qty =item['QTY']?Number(item['QTY']):0
                    let v_taxamt =(v_prc*v_tax/100).toFixed(2)
                    let v_amt = Number((v_prc*v_qty).toFixed(2)) //+Number(v_taxamt)
                    this.dtlData.splice(index,1,Object.assign(item,{AMT:v_amt,TAXAMT:v_taxamt}))
                    if (this.v_rmk ){
                        this.dtlData.splice(index,1,Object.assign(item,{RMK:this.v_rmk}))
                    }
                }
            })
        },
        qryDtl(){
            if (this.v_idseq){
                this.getDtlData(this.v_idseq)
            }
        },
        qryFee(){
            if (this.v_idseq){
                this.getFeeNext(this.v_idseq)
            }
        },
        getFeeNext(idseq){
            let cond_=''
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.txtparam4+'%\' '
                }else{
                    cond_=cond_+' and '+this.selparam4  +this.oper4+' \''+this.txtparam4+'\' '
                }
            }
            this.payData=[]
 
            getTabColOrData(this.v_url,'V_PO_DTLREP','idseq',idseq,'','','','',cond_).then((res) => {    
                this.payData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refpay'].doLayout()
                })
            })
        },
        async stfgRec(row,val,index,v_comm){
            const res = await this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'IDSEQ',p_value:row.IDSEQ, p_table:'po_orddtl',p_cond:' and prc is null'},
            }) 
            if (res.result && res.result.length>0){
                this.promptWin =true
                this.prompt ='明细记录中存在单价为空，请核查'
                return
            }  
            
            
            var vm=this ,v_cond='',v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser='' ,v_title=''
            if (val =='K') {                          
                if( v_comm=='弃审'){
                    v_cfmdttm =''
                    v_cfmuser =''
                }else{
                    v_cfmdttm =getDate('full')
                    v_cfmuser =this.v_usernm
                }
                v_chkuser='',v_chkdttm=''
                v_cond =' set stfg=\''+val+'\',cfmuser=\''+v_cfmuser+'\',cfmdate=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',cfmuser=\''+v_cfmuser+'\',cfmdate=\''+v_cfmdttm+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\''
            }
            let v_bool =false
            if( v_comm=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            if (val =='K' && row['DAYS']<3){
                v_title ='请注意：交货日期与订单日期小于3天，你确定要'+v_comm+'此单据吗?'
            }else{
                v_title ='你确定要'+v_comm+'此单据吗?'
            }
            if (v_bool){
                this.promptWin =true
                this.prompt ='当前用户:'+this.v_usernm+' 与审核用户：'+row['CHKUSER']+'不同时不能弃审'
            }else{
                this.$confirm(v_title,'提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    type:'info',
                }).then(()=>{
                    this.d_stfg=true
                    // 删除 只是把状态变更为作废 ，如果入库单引用了 采购单，则不能删除
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'REFIDSEQ',p_value2:row.IDSEQ,p_cond:' and stfg not in (\'X\',\'C\')',p_table:'V_IC_STKdtl'},
                    }).then(res=>{ 
                        if (val=='X' && res.result.length>0){
                            this.d_stfg=false
                            this.promptWin =true
                            this.prompt ='已生成入库单后不能作废'
                        }else {
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_ord',p_cond: v_cond},
                            }).then(res=>{      
                                if(res.code =='200')  {
                                    if (val=='X'){
                                        this.tabData.splice(index,1)
                                    }else{        
                                        Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,CFMUSER:v_cfmuser,CFMDATE:v_cfmdttm})           
                                    }
                                }else{
                                    this.prompt=res.result
                                    this.promptWin =true
                                }        
                            })
                            //发起审批时
                            if (val =='K'){
                                // 调用工作流启动函数
                                startWorkflowInstance({
                                    flowId: '108',
                                    businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                                    actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                                    component: this,
                                    axios: this.$axios,
                                    baseUrl: '',
                                    // 微信消息相关参数
                                    docType: '采购订单', // 单据类型
                                    DIRNM: row.SUPNM, // 项目名称，使用文件名
                                    CNAME: row.MATNM,
                                    businessData: {
                                        flowType: 3,
                                        qty: null,
                                        amt: row['TTLAMT'],
                                    },
                                    jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                                })
                                this.d_stfg=false
                            }else if( v_comm =='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/updateRec',
                                    data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                                }).then(res=>{
                                    this.d_stfg=false
                                    // 在日志表中 插入 一条 弃认记录
                                    let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃认'}
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                    }) 
                                })
                            }else if( v_comm =='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/updateRec',
                                    data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                                }).then(res=>{
                                    // 在日志表中 插入 一条 弃认记录
                                    let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃审'}
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                    }).then(res=>{ 
                                        this.d_stfg=false  
                                    })
                                })
                            }else{
                                this.d_stfg=false
                            }
                 
                        }
                    })
                }).catch(()=>{})  
            }          
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                if (this.v_corpid=='300'){
                    this.repUrl =this.$store.state.repUrl+ 'rep_poord2.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else{
                    this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }
            }
            //this.repUrl =this.$store.state.repUrl+'porep.cpt'+'&p_pono='+row['IDNO']+'&p_idseq='+row['IDSEQ']
        },
        supChg(val){
            this.supArr.some(item=>{
                if (item['IDSEQ']==val){
                    this.mainRow['TELNO']=item['PERTELNO']
                }
            })
        },
        stfgBtn(row,index){
            this.stfgWin =true
            if (row['ORDSTFG']!=='N' && row['ORDSTFG']!=='Y'){
                this.stfgNo =row['ORDSTFG']
            }
            this.v_stfgseq =JSON.parse(JSON.stringify(row))
            this.v_index =index
        },
        //状态变更确认
        stfgSure(){
            let v_comm='',v_cond=''
            if (!this.stfgNo ){
                this.promptWin =true
                this.prompt ='请选择状态'
            }else {
                v_comm ='你确定要变更状态吗?'
                this.$confirm(v_comm,'提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    v_cond =' set ordstfg=\''+this.stfgNo+'\',STFGDTTM=\''+getDate('day')+'\',UPDUSER=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\''
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:this.v_stfgseq['IDSEQ'],p_table:'po_ord',p_cond:v_cond },
                    }).then(res=>{  
                        this.stfgWin=false
                        this.tabData.splice(this.v_index,1,Object.assign(this.v_stfgseq,{ORDSTFGNM:this.stfgNm,ORDSTFG:this.stfgNo}))
                    })
    
                }).catch(()=>{})
            }
        },
        rmkSure(){
            if (this.mainRow['RMK']){
                this.$confirm('采购备注不为空时，会覆盖已有记录，要继续吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.mainRow['RMK'] =this.tmplRmk
                    this.rmkWin=false
                }).catch(()=>{})
            }else{
                this.mainRow['RMK'] =this.tmplRmk
                this.rmkWin=false
            }
        },
        selRmk(){
            this.rmkWin =true
        },
 
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='QTY' ){
               // this.dtlData.splice(index,1, Object.assign(row,{ AMT:(Number(row['QTY'])*Number( row['PRC'])).toFixed(2)} ))  
                row['AMT']= (Number(row['QTY'])*Number( row['PRC'])).toFixed(2)        
            }
        },
 
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']
            
        },
 
        perClick(row){
            this.chkIndex =row.index  
        },
 
        dtlDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row={'MATTY':'MAT'  }
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'108', p_key3:'edcss',p_value3:'select',p_cond:' and lstseq in (2627,1)'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {   
                //明细记录判断非空字段不能为空
                let v_Flag=false  ,v_title='' 
                this.dtlData.forEach(item=>{
                    this.dtlCol.filter(item2=>item2.notnull=='Y').some(it=>{
                        if (!item[it['key']]){
                            v_Flag =true
                            v_title=it['title']
                        }
                    })
                })
 
                if (v_Flag ){
                    this.promptWin =true
                    this.prompt ='明细资料中的 "'+v_title +'" 不能为空'
                    return
                }
                if (this.v_commit ) { //防止点多次保存 
                    this.v_commit =false
                    let obj_ ={},amt_=0,actamt_=0
                    //汇总明细金额
                    if(this.dtlData.length>0){
                        for(let k=0;k<this.dtlData.length;k++){
                            if(this.dtlData[k]['AMT']){
                                amt_=Number(amt_)+Number(this.dtlData[k]['AMT'])
                            }
                        }
                    }
                    if(this.feeData.length>0){
                        for(let k=0;k<this.feeData.length;k++){
 
                            if(this.feeData[k]['AMT']){
                                amt_=Number(amt_)+Number(this.feeData[k]['AMT'])
                            }
                        }
                    }
                    //应收金额
                    if(this.mainRow['DISFEE']) {
                        actamt_=Number(amt_)-Number(this.mainRow['DISFEE'])
                    }else{
                        actamt_=Number(amt_)
                    }    
                    Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid,AMT:amt_.toFixed(2),ACTFEE:actamt_.toFixed(2)}) 
                
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'po_ord',frmid:'108'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            //明细保存：批量保存  
                            let v_idseq =res.idseq
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'po_orddtl',p_idseq:v_idseq,p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            })
                            //明细删除
                            if (this.delArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delArr), p_table:'po_orddtl',p_idseq:v_idseq,p_action:'D' },
                                })
                            }     
                            //3、图片保存
                            for(var k=0;k<this.imgData.length;k++){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:v_idseq},
                                })
                            }
                            //删除服务器上的真实附件
                            for(let k=0;k<this.delData.length;k++){
                                let v_filepath=this.delData[k]['FILEPATH'],v_path=this.delData[k]['PATH']
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:this.delData[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delData[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delData[k]['FILEPATH'],p_table:'mat_img'},
                                }).then(res=>{
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{
                                            console.log(res.result)
                                        })
                                    }
                                })
                            }

                            //费用明细保存：批量保存  
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.feeData), p_table:'po_ordfee',p_idseq:v_idseq,p_action:'S' },
                            }).then(res=>{
                                if (res.code !=='200'){
                                    this.promptWin =true
                                    this.prompt =res.result
                                }
                            })  
                            //明细删除
                            if (this.delFee.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delFee), p_table:'po_ordfee',p_idseq:v_idseq,p_action:'D' },
                                })
                            } 
                            // websocket 发送消息
                            // if("WebSocket" in window){
                            //     var ws =new WebSocket(this.$store.state.wsUrl+this.v_username)
                            //     if (ws.readyState ==1) {
                            //         ws.send('poord_save') 
                            //     }
                            // }else{
                            //     this.promptWin =true
                            //     this.prompt ='你的浏览器不支持websocket' 
                            // }
                            vm.drawer =false   
                            
                            vm.inputQry()
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
  
        //订单明细
        getOrdList(cond){
            //获取所有产品记录且初始化分页记录      
            this.v_loading =true
            const requestId =++this.queryRequestId
            const orderField =isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO'
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'POTY', p_value:'PRD',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+orderField+' desc' ,p_table:'V_po_ord'},
            }).then(res=>{
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.promptWin=true
                this.prompt=error.message || this.$LANG('1641', '查询失败')
            }).finally(()=>{
                if (requestId !== this.queryRequestId) return
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                    this.v_loading =false
                })
            })
        },
        //查询明细数据
        getDtlData(idseq){
            let cond_=''
            if (this.selparam3){ //列1      
               cond_=cond_+' and  '+this.selparam3+'  like  \'%' + this.txtparam3+'%\' '
            }
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.txtparam4+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam4  +this.oper4+' \''+this.txtparam4+'\' '
                }
            }
            this.dtlData=[]
            this.loading =true
            getTabColOrData(this.v_url,'V_po_orddtl','idseq',idseq,'','','','',cond_+' order by matno').then((res) => {    
                this.dtlData =res.result  
                this.$nextTick(()=>{            
                    this.loading =false
                    this.$refs['refdtl'].doLayout()
 
                })
            })

        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
    
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        selRec(row){

        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{ 
               this.saveFlag=false
            }
            this.v_commit =true
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true   
            this.delArr=[]
            this.qryImgData(row.IDSEQ)
            this.getFeeData(row.IDSEQ)  
            this.getDtlData(row.IDSEQ)
        },
        qryImgData(idseq){
            getTabColOrData(this.v_url, 'V_mat_img','idseq',idseq,'','').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
        initData(){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'PATH',p_value2:this.$route.path,p_cond:' and userno=\''+this.v_username+'\'',p_table:'V_QRY_COND'},
            }).then(res=>{ 
                let v_row =res.result
                if (v_row.length==0){
                   this.qryTabData() 
                }else{
                    let v_sel='',v_text='',v_sel2='',v_text2=''
                    if (v_row[0]['SELPARAM']){
                        v_sel =v_row[0]['SELPARAM']
                    }
                    if (v_row[0]['TXTPARAM']){
                        v_text =v_row[0]['TXTPARAM']
                    }
 
                    this.selparam =v_sel
                    this.oper =v_row[0]['OPER']
                    this.txtparam =v_text
                
                    this.stfg_ =v_row[0]['STFG']
                    this.qryTabData()
                }
            })
        },
        buildMainQueryCondition(){
            let condition =buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper, {
                numberOperatorDefault: '>=',
                allowDateOperators: true,
            })
            condition +=buildVeTableHeaderCondition(this.initCol, this.v_row, {
                numberOperatorDefault: '>=',
                typeOverrides: {
                    STFG: 'select',
                    ORDSTFGNM: 'select',
                },
            })
 
            if (this.stfg_==='NF') {
                condition += ' and ( ORDstfg NOT IN (\'OK\',\'END\') or (ordstfg in (\'OK\',\'END\') and stfgdttm>=\''+getDate2(3)+'\') )'
            } else if (this.stfg_==='N') {
                condition += ' and stfg in (\'N\',\'K\')'
            } else if (this.stfg_!=='ALL') {
                condition += ' and stfg=\'Y\''
            }
            return condition
        },
        //查询
        qryTabData(){
            this.current =1
            this.headerSortKey =''
            this.headerSortOrder =''
            this.getOrdList(this.buildMainQueryCondition())
        },
        getTabList(){
            this.qryTabData()
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={ORDDTTM:getDate('day'),STFG:'N',STAFFNM:this.v_usernm,CRCY:'4238' }
            this.saveFlag=false
            this.dtlData=[]
            this.delArr=[]
            this.imgData=[]
            this.v_commit =true
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
        stfgChg(val){
            this.stfgArr.some(item=>{
                if (item['CODE']==val){
                    this.stfgNm =item['CNAME']
                }
            })
        },
        renderPoBodyCell(row, column, item, rowIndex){
            const key = item.key
            const value = row[key]
            const type = String(item.EDCSS || item.edcss || '').toLowerCase()
            if (key === 'IDNO') {
                return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;font-size:12px;text-align:center">{value}</div></el-link>
            }
            if (key === 'ORDSTFGNM') {
                return <el-link underline={false} on-click={() => this.stfgBtn(row, rowIndex)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px">{value}</div></el-link>
            }
            if (type === 'checkbox' && key !== 'STFG') {
                return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[key]}></el-checkbox>
            }
            if (key === 'IMGPATH') {
                if (value && String(value).toLowerCase().lastIndexOf('.pdf') > -1) {
                    return <el-link underline={false} on-click={() => this.imgPreview(value)}><i class="iconfont icon-pdf"></i></el-link>
                }
                return <el-image style="width:100%;height:20px" src={value} preview-src-list={value ? [value] : []}><div slot="error"><i class="el-icon-picture-outline"></i></div></el-image>
            }
            if (key === 'STFG') {
                if (value === 'Y') return <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                if (value === 'N') return <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                if (value === 'K') return <el-tag size="mini" type="danger" effect="dark">{this.$LANG('1982', '已确认')}</el-tag>
                if (value === 'P') return <el-tag size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag>
                if (value === 'NF') return <el-tag size="mini" type="success" effect="dark">{this.$LANG('2004', '未完成')}</el-tag>
            }
            return <div style="width:100%">{value}</div>
        },
        renderPoOperationCell(row, rowIndex){
            return <div>
                {row.STFG === 'Y' ? <span><i class="iconfont icon-xiashuangjiantou" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.editBool} on-click={() => this.nextGen(row, rowIndex)} underline={false}><span style="font-size:12px;margin-right:2px">{this.$LANG('0242', '下推')}</span></el-link></span> : null}
                <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.disabled} on-click={() => this.editRec(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:3px">{this.$LANG('0139', '查看')}</span></el-link>
                {row.STFG === 'N' || this.v_username === '18025667613' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N')} underline={false}><span style="font-size:12px;margin-right:2px">{this.$LANG('1639', '编辑')}</span></el-link></span> : null}
                {row.STFG === 'N' ? <span><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.editBool || this.d_stfg} on-click={() => this.stfgRec(row, 'K', rowIndex, '确认')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0364', '确认')}</span></el-link></span> : null}
                {row.STFG === 'K' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.editBool} on-click={() => this.stfgRec(row, 'N', rowIndex, '弃认')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0314', '弃认')}</span></el-link></span> : null}
                {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'N', rowIndex, '弃审')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
                {row.STFG === 'N' ? <span><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px"></i><el-link on-click={() => this.stfgRec(row, 'X', rowIndex, '作废')} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link></span> : null}
            </div>
        },
        //获取表列字段
        getTabField(){
            let vm =this
            this.tabArr = []
            this.vueCol = []
            const mainFieldPromise = getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then((res) => {
                const fieldRows = vm.sortFieldRows(res.result)
                vm.tabArr = []
                vm.vueCol = []
                fieldRows.forEach(item => {
                    const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                    vm.tabArr.push({
                        title,
                        key: item.key,
                        align: item.align,
                        width: item.width,
                        thide: item.THIDE,
                        fhide: item.FHIDE,
                        edcss: item.EDCSS,
                        disabled: item.DISABLED,
                        sortable: item.SORTABLE,
                        dotnum: item.DOTNUM,
                    })
                    if (item.THIDE !== 'N') return
                    vm.vueCol.push({
                        field: item.key,
                        key: item.key,
                        title,
                        align: item.align,
                        width: Number(item.width) || 120,
                        sortable: false,
                        ellipsis: { showTitle: true },
                        renderHeaderCell: ({column}) => <VeTableQueryHeader
                            title={column.title}
                            edcss={item.key === 'STFG' || item.key === 'ORDSTFGNM' ? 'select' : item.EDCSS}
                            value={vm.v_row[item.key]}
                            operator={vm.v_row[`#OPER${item.key}`]}
                            defaultOperator=">="
                            showDateOperator={false}
                            sortable={item.key !== 'RN' && item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'}
                            sortOrder={vm.headerSortKey === item.key ? vm.headerSortOrder : ''}
                            options={item.key === 'STFG' ? [
                                { value: 'NF', label: vm.$LANG('2004', '未完成') },
                                { value: 'N', label: vm.$LANG('2005', '未审核') },
                                { value: 'K', label: vm.$LANG('1982', '已确认') },
                                { value: 'Y', label: vm.$LANG('1976', '已审核') },
                            ] : item.key === 'ORDSTFGNM' ? [
                                { value: '未开始', label: vm.$LANG('2007', '未开始') },
                                { value: '进行中', label: vm.$LANG('2017', '进行中') },
                                { value: '部分完成', label: vm.$LANG('2020', '部分完成') },
                                { value: '终止', label: vm.$LANG('0377', '终止') },
                                { value: '逾期', label: vm.$LANG('0404', '逾期') },
                            ] : []}
                            on-input={(value) => vm.$set(vm.v_row, item.key, value)}
                            on-operator-change={(value) => vm.$set(vm.v_row, `#OPER${item.key}`, value)}
                            on-title-click={() => vm.sortHeaderColumn(column, item.EDCSS)}
                            on-query={vm.inputQry}
                        />,
                        renderBodyCell: ({row, column, rowIndex}) => vm.renderPoBodyCell(row, column, item, rowIndex),
                    })
                })
                vm.vueCol.unshift({
                    field: 'index',
                    key: 'rownum',
                    title: vm.$LANG('0310', '序号'),
                    width: 60,
                    align: 'center',
                    fixed: 'left',
                    renderHeaderCell: () => (
                        <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff">
                            <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light">
                                <i class="iconfont icon-shanchu1"></i>
                            </el-tooltip>
                        </el-link>
                    ),
                    renderBodyCell: ({row, rowIndex}) => (
                        <div style="display:flex;align-items:center;justify-content:center">
                            <span>{rowIndex + ((vm.current - 1) * vm.rowSize) + 1}</span>
                            {row.PAYSRC === '433336' ? <span style="margin-left:4px;font-size:12px;width:20px;height:20px;background:red;color:white;padding-left:4px">{this.$LANG('0832', '代')}</span> : null}
                        </div>
                    ),
                })
                vm.vueCol.push({
                    field: 'oper0',
                    key: 'oper',
                    title: vm.$LANG('0330', '操作'),
                    align: 'center',
                    width: 205,
                    fixed: 'right',
                    disableResizing: true,
                    renderBodyCell: ({row, rowIndex}) => vm.renderPoOperationCell(row, rowIndex),
                })
                vm.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','2310','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','2627','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.feeCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','411421','lstseq','1','thide','N',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.unitCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            return mainFieldPromise
        }
    }
}
</script>
<style scoped lang="less">
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-one {
        width: 32%;
        height: 40px;
 
    }
    .item-width2{
        width: 48%;
    }
    .item-width{
        width:32%;
        height: 16px !important;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
</style>
<style lang="less">
    .po-ord-status-legend {
        color: #606266;
        margin: 7px 12px 7px 15px;
        font-size: 12px;
        width: max-content;
        min-width: 700px;
        flex: 0 0 auto;
        white-space: nowrap;
        font-weight: 600;
    }
    #po_ord_table .ve-table-content-wrapper {
        min-height: 100%;
    }
    #po_ord_table .table-head-cell-class,
    #po_ord_table .table-head-cell-class2 {
        font-size: 12px !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
    }
    #po_ord_table .table-head-cell-class {
        color: #03274b !important;
    }
    #po_ord_table .table-head-cell-class2 {
        color: rgb(134, 4, 4) !important;
    }
    #po_ord_table .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding: 2px !important;
        border-color: #808695 !important;
        height: 20px !important;
    }
    #po_ord_table .table-body-cell-class1.po-ord-gray-row { color: #808080 !important; }
    #po_ord_table .table-body-cell-class1.po-ord-blue-row { color: blue !important; }
    #po_ord_table .table-body-cell-class1.po-ord-yellow-row { color: #b8b81b !important; }
    #po_ord_table .table-body-cell-class1.po-ord-green-row { color: green !important; }
    #po_ord_table .table-body-cell-class1.po-ord-end-row { color: red !important; }
    #po_ord_table .table-body-cell-class1.po-ord-deep-row { color: #065279 !important; }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .gray-row  {
        color: #808080;
    }
    .ve-table .po-ord-gray-row {
        color: #808080;
    }
    .el-table .blue-row  {
        color: blue;
    }
    .ve-table .po-ord-blue-row {
        color: blue;
    }
    .el-table .yellow-row  {
        color: #b8b81b;
    }
    .ve-table .po-ord-yellow-row {
        color: #b8b81b;
    }
    .el-table .green-row  {
        color: green;
    }
    .ve-table .po-ord-green-row {
        color: green;
    }
    .el-table .end-row  {
        color: red;
    }
    .ve-table .po-ord-end-row {
        color: red;
    }
    .el-table .deep-row  {
        color: #065279;        
    }
    .ve-table .po-ord-deep-row {
        color: #065279;
    }
    
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
        border-top-color: #fff;
        color: #999;
        box-shadow: 0 2px 12px 0 rgb(250, 245, 245);
    }
    .atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
        border-top-color: #fff;
        color: #999;
        box-shadow: 0 2px 12px 0 rgb(236, 231, 231)
    }
    .atooltip {
        background: #fff !important;
        color: #999 !important;
        box-shadow: 0 2px 4px 0 rgba(151, 41, 41 ) !important;
    }
    .el-tooltip__popper.is-dark{
        border-right-color: #fff;
        border-top-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(212, 21, 21 );
        color: #999;
    }
 
</style>
